module.exports = __webpack_public_path__ + "img/sld_scb_5_green.bbfd20d5.svg";